export enum BankAccountType {
    Checking = 'Checking',
    Savings = 'Savings',
    Investment = 'Investment',
}

export const BANK_ACCOUNT_TYPE_OPTIONS: { value: BankAccountType; display: string }[] = [
    { value: BankAccountType.Checking, display: 'Checking' },
    { value: BankAccountType.Savings, display: 'Savings' },
    { value: BankAccountType.Investment, display: 'Investment' },
];
